/** API route map: URLS.Controller.ClientContactAttachment */
export const ClientContactAttachment = {
      Name: 'ClientContactAttachment/',
      GetAll: 'clientContact-attachments',
      Add: 'add',
      DeleteAttachment: 'delete',
};
